export interface AuthEventsData {
    AuthEvents: AuthEventData[]
}

export interface AuthEventData {
    EventId: string;
    EventType: string;
    CreationDate: string;
    EventResponse: string;
    EventRisk: EventRisk,
    ChallengeResponses: [
        {
            ChallengeName: string;
            ChallengeResponse: string;
        }
    ],
    EventContextData: EventContextData
}

interface EventRisk {
    RiskDecision: string;
    RiskLevel: string;
    CompromisedCredentialsDetected: boolean;
}

interface EventContextData {
    IpAddress: string;
    DeviceName: string;
    City: string;
    Country: string;
}
